var _path, _path2, _path3, _path4, _path5, _rect, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWord = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M9 4a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v7H9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M9 11h30v9H9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M9 20h30v9H9z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#e)",
  d: "M21 10v18a2 2 0 0 1-2 2H1"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  x: 1,
  y: 10,
  fill: "url(#f)",
  rx: 2
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6.052 15 1.991 8.35 2.052-8.288h1.946l2.082 8.273L16.053 15H18l-2.972 11h-1.825l-2.188-8.658L8.858 26H7.093L4 15z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 24,
  x2: 24,
  y1: 2,
  y2: 11,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0082C8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009BE6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 24,
  x2: 24,
  y1: 11,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0262AA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0188DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 24,
  x2: 24,
  y1: 20,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0656AB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0765C1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 24,
  x2: 24,
  y1: 29,
  y2: 38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0A3B84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0C4CA6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 21,
  x2: 12.5,
  y1: 30,
  y2: 21.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.22
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 1,
  x2: 21,
  y1: 16,
  y2: 29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0B3166"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#024C9A"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWord);
export default ForwardRef;